import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const Support = () => {
  return (
    <Typography
      sx={{ fontSize: "1rem", color: "#232323", align: "left", mt: 2 }}
    >
      To request access please lodge a service request <br />
      using <a
          href="https://lendleasegroup.atlassian.net/servicedesk/customer/portals"
          target="="
        >JSM</a></Typography>
  );
};

export default Support;
